export const profileTabs = [
  {
    displayValue: "profile_details",
  },
  {
    displayValue: "settings",
  },
];
